import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgLogin2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M30 3a27 27 0 1 0 27 27A27.03 27.03 0 0 0 30 3m12.673 44.951a21.91 21.91 0 0 1-25.363-.013v-.8a12.682 12.682 0 1 1 25.363 0zM25.23 24.427a5.012 5.012 0 1 1 5.012 5.012 5.02 5.02 0 0 1-5.012-5.012m22.084 19.1a17.61 17.61 0 0 0-9.688-12.344 10.025 10.025 0 1 0-14.918-.166 17.63 17.63 0 0 0-10.035 12.495 21.988 21.988 0 1 1 34.641.016z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogin2);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
